module.exports = __webpack_public_path__ + "static/media/insta.5dd8554d.png";